export default __webpack_public_path__ + "20ff88352d7db9c4ff2d4eefe82f8b51.png";